export default {
  methods: {
    loginWithGlobalPlayer () {
      this.$router.push({ name: 'login' })
    }
  }
}
